// src/pages/auth/LoginPage.jsx
import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { loginWithEmail, loginWithGoogle } from "../../services/authService";
import Button from "../../components/ui/Button";
import Input  from "../../components/ui/Input";
import styles from "./AuthPages.module.css";

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/dashboard";

  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);

  const handleEmailLogin = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try { await loginWithEmail(email, password); navigate(from, { replace: true }); }
    catch (err) { setError(friendlyError(err.code)); }
    finally { setLoading(false); }
  };

  const handleGoogleLogin = async () => {
    setError(""); setLoading(true);
    try { await loginWithGoogle(); navigate(from, { replace: true }); }
    catch (err) { setError(friendlyError(err.code)); }
    finally { setLoading(false); }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.brand}>
          <span className={styles.logo}>GS</span>
          <h1 className={styles.title}>Gigscout</h1>
        </div>
        <h2 className={styles.heading}>Welcome back</h2>
        <p className={styles.sub}>Sign in to your account</p>
        {error && <div className={styles.errorBanner}>{error}</div>}
        <form onSubmit={handleEmailLogin} className={styles.form}>
          <Input label="Email"    id="email"    type="email"    value={email}    onChange={e => setEmail(e.target.value)}    placeholder="you@example.com" required />
          <Input label="Password" id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••"       required />
          <div className={styles.forgotRow}><Link to="/forgot-password">Forgot password?</Link></div>
          <Button type="submit" fullWidth loading={loading}>Sign In</Button>
        </form>
        <div className={styles.divider}><span>or</span></div>
        <Button variant="secondary" fullWidth onClick={handleGoogleLogin} disabled={loading}>
          <GoogleIcon /> Continue with Google
        </Button>
        <p className={styles.footer}>Don't have an account? <Link to="/register">Create one</Link></p>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615Z" fill="#4285F4"/>
      <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18Z" fill="#34A853"/>
      <path d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332Z" fill="#FBBC05"/>
      <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58Z" fill="#EA4335"/>
    </svg>
  );
}

function friendlyError(code) {
  switch (code) {
    case "auth/user-not-found":
    case "auth/wrong-password":
    case "auth/invalid-credential": return "Invalid email or password.";
    case "auth/too-many-requests":  return "Too many attempts. Please try again later.";
    case "auth/popup-closed-by-user": return "Sign-in popup was closed.";
    default: return "Something went wrong. Please try again.";
  }
}
